export async function getNetworkSettings() {
  const settingsResponse = await fetch("./settings.json");
  const settings = await settingsResponse.json();
  return {
    DeviceAdapterUrl: settings.deviceAdapter.url,
    AdcWebSocketUrl: settings.adcSender.url,
    EventsWebSocketUrl: settings.eventSender.url,
    TerminalWebSocketUrl: settings.terminal.url
  };
}
